module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/email_docs_tags-a98699896fc1546b338dbbfb372681a2.svg";